export default {
      id: "icon-staravis-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "icons.svg#icon-staravis",
      toString: function () {
        return this.url;
      }
    }